import defaultValues from './defaultValues'

const after = JSON.parse(defaultValues);

export const after_hover = JSON.parse(defaultValues);
export const after_active = JSON.parse(defaultValues);
export const after_focus = JSON.parse(defaultValues);
export const after_target = JSON.parse(defaultValues);
export const after_disabled = JSON.parse(defaultValues);
export const after_invalid = JSON.parse(defaultValues);

export default after;